var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"block lg:flex lg:flex-wrap"},_vm._l((_vm.pastEvents),function(event){return _c('event-card',{key:event.id,staticClass:"mx-auto mb-2 lg:w-1/3 lg:ml-2",attrs:{"event":event}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }